// 応募しない求人一覧
import axios from '@/plugins/axios';
import { endpoint } from '@/api/apiConstants';
import { TrnOrderJobSearchPublicRequest } from '@/types/request';

type LocationInfo = {
  orderIds: number[];
  locationNo: string;
};

type LocationMtInfo = {
  orderIds: string[];
  locationNo: string;
};

export const fetchJobSearchPublicList = async (params: TrnOrderJobSearchPublicRequest) => {
  const res = await axios.post(endpoint.getJobSearchPublicList, params);
  return res;
};

export const fetchOrderInfo = async (orderId: string, isBrowsing = false, isNeedCheckValidate= false, isPublic = false, isBooster = false) => {
  const params = {
    'orderId' : orderId,
    'isBrowsing': isBrowsing,    
    'isNeedCheckValidate' : isNeedCheckValidate,
    'isPublic' : isPublic,
    'isBooster' : isBooster
  };
  const res = await axios.post(endpoint.getOrderDetail, params);
  return res;
};

export const fetchLocation = async (params: LocationInfo) => {
  const res = await axios.post(endpoint.getLocation, params);
  return res;
};

export const fetchLocationMt = async (params: LocationMtInfo) => {
  const res = await axios.post(endpoint.getLocationMt, params);
  return res;
};

export const fetchCityName = async (cityId: number) => {
  const res = await axios.get(`${endpoint.getCityName}/${cityId}`);
  return res;
};

export const fetchSchlName = async (schlid: number) => {
  const res = await axios.get(`${endpoint.getSchName}/${schlid}`);
  return res;
};

export const fetchEmptypeById = async (id: number) => {
  const res = await axios.get(`${endpoint.getEmpType}/${id}`);
  return res;
};


export const fetchTrnClientById = async (id: number) => {
  const res = await axios.get(`${endpoint.getTrnClient}/${id}`);
  return res;
};

export const fetchTrnClientMtById = async (id: number) => {
  const res = await axios.get(`${endpoint.getTrnClientMt}/${id}`);
  return res;
};

export const fetchMarketName = async (id: number) => {
  const res = await axios.get(`${endpoint.getMarketName}/${id}`);
  return res;
};

export const fetchOverTimeName = async (id: number) => {
  const res = await axios.get(`${endpoint.getOverTimeName}/${id}`);
  return res;
};

export const fetchRemoteWorkName = async (id: number) => {
  const res = await axios.get(`${endpoint.getRemoteWorkName}/${id}`);
  return res;
};

export const fetchSideBusinessName = async (id: number) => {
  const res = await axios.get(`${endpoint.getSideBusinessName}/${id}`);
  return res;
};

export const fetchPassiveSmokingName = async (id: number) => {
  const res = await axios.get(`${endpoint.getPasiveSmokingName}/${id}`);
  return res;
};

export const fetchCategPassiveSmokingMeasureName = async (id: number) => {
  const res = await axios.get(`${endpoint.getCategPasiveSmokingMeasureName}/${id}`);
  return res;
};

export const fetchTrnShintyokuInfo = async (orderId: number) => {
  const params = {
    'orderId' : orderId
  };
  const res = await axios.post(endpoint.getShintyoku, params);
  return res;
};

export const fetchResultAmonutName = async (id: number) => {
  const res = await axios.get(`${endpoint.getResultAmountName}/${id}`);
  return res;
};

export const fetchRailwayNameByStation = async (id: number) => {
  const res = await axios.get(`${endpoint.getRailwayNameByStation}/${id}`);
  return res;
};

export const fetchStationName = async (id: number) => {
  const res = await axios.get(`${endpoint.getStationName}/${id}`);
  return res;
};

export const fetchWalkbusName = async (id: number) => {
  const res = await axios.get(`${endpoint.getWalkbusName}/${id}`);
  return res;
};
export const fetchWorkType = async (id: number) => {
  const res = await axios.get(`${endpoint.getWorkType}/${id}`);
  return res;
};

export const getOrderInfo = async (orderId: number) => {
  const res = await axios.get(`${endpoint.getOrderInfo}/${orderId}`);
  return res;
};

export const getAllEmpType = async () => {
  const res = await axios.get(`${endpoint.getEmpType}/all`);
  return res.data;
};
